import React from "react";
import {
  FaInstagram,
  FaGraduationCap,
  FaSchool,
  FaUniversity,
  FaLinkedin,
} from "react-icons/fa";
import { RiSchoolLine } from "react-icons/ri";

export default function AboutMe() {
  const hobbies = [
    {
      title: "Travelling",
      description:
        "Exploring new places and cultures is my passion. I love experiencing the beauty of the world, one destination at a time.",
      image: "./assets/about/travellingport.webp",
      icons: [
        { icon: <FaInstagram />, link: "https://instagram.com/joey007_" },
        //{ icon: <FaYoutube />, link: "https://youtube.com/yourchannel" },
      ],
    },
    {
      title: "Workouts",
      description:
        "Fitness is a core part of my routine. Whether it's bodyweight exercises,weight training or cardio, I enjoy pushing my limits.",
      image: "./assets/about/posing.webp",
      icons: [
        { icon: <FaInstagram />, link: "https://instagram.com/joey007_" },
      ],
    },
    {
      title: "Vintage Motorcycles",
      description:
        "Restoring and maintaining vintage motorcycles is a unique way for me to combine my love for history and engineering.",
      image: "./assets/about/yezdisolo.webp",
      icons: [
        { icon: <FaInstagram />, link: "https://instagram.com/joey007_" },
      ],
    },
    {
      title: "Trekking",
      description:
        "I love climbing heights to find out what it's like from there",
      image: "./assets/about/moutwithdog.webp",
      icons: [
        { icon: <FaInstagram />, link: "https://instagram.com/joey007_" },
      ],
    },
    {
      title: "Music",
      description:
        "Music is my creative outlet. Playing the guitar helps me unwind and express myself in ways words can't.",
      image: "./assets/about/guitar.webp",
      icons: [
        { icon: <FaInstagram />, link: "https://instagram.com/joey007_" },
      ],
    },
  ];

  const education = [
    {
      level: "School",
      institution: "Stella Maris School",
      years: "2017 - 2018",
      description:
        "Foundation years that shaped my curiosity and love for learning",
      icon: <FaSchool />,
    },
    {
      level: "Intermediate",
      institution: "S.E.R.Jr. College",
      years: "2018 - 2020",
      description: "Chose MPC(Maths Physics Chemistry)",
      icon: <RiSchoolLine />,
    },
    {
      level: "Bachelor's",
      institution: "Anil Neerukonda Institute of Technology and Sciences",
      years: "2020 - 2024",
      description:
        "Specialized in my field and built the foundation for my career.B.Tech. Information Technology",
      icon: <FaGraduationCap />,
    },
    {
      level: "Master's",
      institution: "Gandhi Institute of Technology and Management",
      years: "2025 - 2027",
      description:
        "Pursuing an MBA with a focus on Finance to enhance managerial, analytical, and strategic decision-making skills for the corporate world.",

      icon: <FaUniversity />,
    },
  ];

  return (
    <div className="min-h-screen overflow-hidden">
      <div
        className="relative w-full min-h-screen"
        style={{
          backgroundImage:
            "linear-gradient(135deg, #12100d 0%, #201a13 50%, #0e0c0a 100%)",
          backgroundAttachment: "fixed",
        }}
      >
        {/* Subtle Background Pattern */}
        <div className="absolute inset-0 opacity-[0.04]">
          <div
            className="absolute inset-0"
            style={{
              backgroundImage: `radial-gradient(circle at 25% 25%, #c9a876 1px, transparent 1px),
                             radial-gradient(circle at 75% 75%, #c9a876 1px, transparent 1px)`,
              backgroundSize: "60px 60px",
            }}
          ></div>
        </div>

        {/* Mystical Floating Elements — softened, no blinking */}
        <div className="absolute inset-0 opacity-30">
          <div className="absolute top-20 left-10 w-1 h-1 bg-[#c9a876] rounded-full"></div>
          <div className="absolute top-40 right-20 w-0.5 h-0.5 bg-[#e8dcc4] rounded-full"></div>
          <div className="absolute bottom-40 left-1/4 w-1 h-1 bg-[#c9a876] rounded-full"></div>
          <div className="absolute top-60 right-1/3 w-0.5 h-0.5 bg-[#e8dcc4] rounded-full"></div>
          <div className="absolute top-80 left-1/3 w-1 h-1 bg-[#c9a876] rounded-full"></div>
          <div className="absolute bottom-60 right-1/4 w-0.5 h-0.5 bg-[#e8dcc4] rounded-full"></div>
        </div>

        {/* Page Header */}
        <div className="relative py-20 text-center">
          {/* Decorative Line */}
          <div className="flex items-center justify-center space-x-4 mb-8">
            <div className="w-12 h-px bg-[#c9a876]"></div>
            <div className="w-2 h-2 border border-[#c9a876] rotate-45"></div>
            <div className="w-12 h-px bg-[#c9a876]"></div>
          </div>

          <h1 className="hero-display text-5xl sm:text-6xl md:text-7xl font-light text-[#f5f0e6] leading-none tracking-wide mb-2">
            About Me
          </h1>
          {/* Educational Timeline Section */}
          <div className="relative container mx-auto px-6 sm:px-12 lg:px-24 py-16">
            {/* Section Header */}
            <div className="text-center mb-16">
              <div className="flex items-center justify-center space-x-4 mb-6">
                <div className="w-12 h-px bg-[#c9a876]"></div>
                <div className="w-1 h-1 bg-[#c9a876] rounded-full"></div>
                <div className="w-12 h-px bg-[#c9a876]"></div>
              </div>
              <h2 className="hero-display text-4xl md:text-5xl font-light text-[#f5f0e6] tracking-wide mb-4 flex items-center justify-center space-x-4">
                Educational Journey
                <a
                  href="https://www.linkedin.com/in/munnangi-joseph-sukumar-63a7b7259/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-[#c9a876] hover:text-white transition-colors duration-300 hover:scale-110 transform"
                >
                  <FaLinkedin />
                </a>
              </h2>
              <p className="hero-body text-[#a89a86] text-lg max-w-2xl mx-auto">
                The path that shaped my knowledge and perspective
              </p>
            </div>

            {/* Timeline */}
            <div className="relative max-w-4xl mx-auto">
              {/* Central Line */}
              <div className="absolute left-6 md:left-1/2 md:-translate-x-1/2 w-px h-full bg-gradient-to-b from-[#c9a876] via-[#c9a876]/50 to-transparent"></div>
              {education.map((edu, index) => (
                <div key={index} className="relative mb-16 last:mb-0">
                  {/* Timeline Node */}
                  <div className="absolute left-6 md:left-1/2 md:-translate-x-1/2 w-6 h-6 bg-[#c9a876] rounded-full border-4 border-black z-10"></div>

                  {/* Content Card */}
                  <div
                    className={`flex items-center ${
                      index % 2 === 0
                        ? "justify-start md:justify-start"
                        : "justify-end md:justify-end"
                    }`}
                  >
                    <div
                      className={`
                      w-full
                      md:w-5/12
                      px-4
                      md:px-0
                      ${index % 2 === 0 ? "md:pr-8" : "md:pl-8"}
                      `}
                    >
                      <div className="group relative bg-black/30 backdrop-blur-sm rounded-none border border-[#c9a876]/30 hover:border-[#c9a876]/50 p-6 transition-all duration-300 hover:scale-105">
                        {/* Decorative Corner */}
                        <div
                          className={`absolute top-0 ${
                            index % 2 === 0 ? "right-0" : "left-0"
                          } w-0 h-0 border-t-[20px] border-t-[#c9a876]/20 ${
                            index % 2 === 0
                              ? "border-l-[20px] border-l-transparent"
                              : "border-r-[20px] border-r-transparent"
                          }`}
                        ></div>

                        {/* Icon */}
                        <div className="flex items-center space-x-3 mb-4">
                          <div className="text-[#c9a876] text-2xl">
                            {edu.icon}
                          </div>
                          <div className="w-8 h-px bg-[#c9a876]"></div>
                        </div>

                        {/* Content */}
                        <h3 className="hero-display text-2xl font-light text-[#f5f0e6] tracking-wide mb-2">
                          {edu.level}
                        </h3>
                        <h4 className="hero-body text-[#c9a876] text-lg font-light mb-2 break-words">
                          {edu.institution}
                        </h4>
                        <p className="hero-body text-[#a89a86] text-sm tracking-wide mb-3">
                          {edu.years}
                        </p>
                        <p className="hero-body text-gray-300 leading-relaxed font-light break-words">
                          {edu.description}
                        </p>

                        {/* Hover Effect Corners */}
                        <div className="absolute -top-1 -left-1 w-3 h-3 border-l border-t border-[#c9a876] opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                        <div className="absolute -top-1 -right-1 w-3 h-3 border-r border-t border-[#c9a876] opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                        <div className="absolute -bottom-1 -left-1 w-3 h-3 border-l border-b border-[#c9a876] opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                        <div className="absolute -bottom-1 -right-1 w-3 h-3 border-r border-b border-[#c9a876] opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
          <div className="flex items-center justify-center space-x-6 mb-8">
            <div className="w-16 h-px bg-[#e8dcc4] opacity-40"></div>
            <h2 className="hero-body text-2xl md:text-3xl font-light text-[#c9a876] tracking-[0.3em] uppercase">
              Beyond Work
            </h2>
            <div className="w-16 h-px bg-[#e8dcc4] opacity-40"></div>
          </div>

          <p className="hero-body text-lg md:text-xl text-[#a89a86] max-w-3xl mx-auto leading-relaxed px-6">
            A glimpse into my world beyond work—my hobbies and passions that
            fuel my creativity and joy.
          </p>
        </div>

        {/* Hobbies Section */}
        <div className="relative container mx-auto px-6 sm:px-12 lg:px-24 py-16">
          {/* Section Header */}
          <div className="text-center mb-16">
            <div className="flex items-center justify-center space-x-4 mb-6">
              <div className="w-12 h-px bg-[#c9a876]"></div>
              <div className="w-1 h-1 bg-[#c9a876] rounded-full"></div>
              <div className="w-12 h-px bg-[#c9a876]"></div>
            </div>
            <h2 className="hero-display text-4xl md:text-5xl font-light text-[#f5f0e6] tracking-wide mb-4">
              Passions & Hobbies
            </h2>
            <p className="hero-body text-[#a89a86] text-lg max-w-2xl mx-auto">
              The activities that bring joy and balance to my life
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
            {hobbies.map((hobby, index) => (
              <div
                key={index}
                className="group relative overflow-hidden transition-all duration-500 hover:scale-105"
              >
                {/* Card Container */}
                <div className="relative bg-black/20 backdrop-blur-sm rounded-none overflow-hidden border border-[#c9a876]/20 hover:border-[#c9a876]/40 transition-all duration-300">
                  {/* Hobby Image */}
                  <div className="relative overflow-hidden h-64">
                    <img
                      loading="lazy"
                      src={hobby.image}
                      alt={hobby.title}
                      className="w-full h-full object-cover filter brightness-[1.03] contrast-[1.03] saturate-[0.92] transition-transform duration-500 group-hover:scale-110"
                    />
                    {/* Image Overlay */}
                    <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent"></div>

                    {/* Border Frame on Image */}
                    <div className="absolute inset-0 border border-[#c9a876]/30"></div>
                  </div>

                  {/* Content */}
                  <div className="relative p-6 bg-gradient-to-b from-black/40 to-black/60">
                    {/* Title with decorative line */}
                    <div className="flex items-center space-x-3 mb-4">
                      <div className="w-6 h-px bg-[#c9a876]"></div>
                      <h2 className="hero-display text-2xl font-light text-[#f5f0e6] tracking-wide">
                        {hobby.title}
                      </h2>
                    </div>

                    <p className="hero-body text-gray-300 leading-relaxed mb-6 font-light">
                      {hobby.description}
                    </p>

                    {/* Icons */}
                    <div className="flex gap-4 items-center">
                      <div className="w-4 h-px bg-[#e8dcc4] opacity-30"></div>
                      {hobby.icons.map((item, idx) => (
                        <a
                          key={idx}
                          href={item.link}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="text-[#c9a876] text-xl hover:text-white transition-colors duration-300 hover:scale-110 transform"
                        >
                          {item.icon}
                        </a>
                      ))}
                    </div>
                  </div>

                  {/* Decorative Corner Elements */}
                  <div className="absolute -top-2 -left-2 w-4 h-4 border-l-2 border-t-2 border-[#c9a876] opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                  <div className="absolute -top-2 -right-2 w-4 h-4 border-r-2 border-t-2 border-[#c9a876] opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                  <div className="absolute -bottom-2 -left-2 w-4 h-4 border-l-2 border-b-2 border-[#c9a876] opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                  <div className="absolute -bottom-2 -right-2 w-4 h-4 border-r-2 border-b-2 border-[#c9a876] opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Bottom Section Divider */}
        <div className="relative py-16 text-center">
          <div className="flex items-center justify-center space-x-4">
            <div className="w-20 h-px bg-[#c9a876]"></div>
            <div className="w-2 h-2 bg-[#c9a876] rounded-full"></div>
            <div className="w-8 h-px bg-[#e8dcc4] opacity-40"></div>
            <div className="w-2 h-2 bg-[#c9a876] rounded-full"></div>
            <div className="w-20 h-px bg-[#c9a876]"></div>
          </div>
        </div>

        {/* Bottom Fade */}
        <div className="absolute bottom-0 left-0 right-0 h-20 bg-gradient-to-t from-black/20 to-transparent"></div>
      </div>
    </div>
  );
}
